export default __webpack_public_path__ + "static/Cashflow 101+202-10-582c0fe8d2bd3f2ad29d557036ed0ce2.jpg";